import {IndexedDBCache} from "finhelper"
import flatpickr from "flatpickr";
import {Russian} from "flatpickr/dist/l10n/ru.js"
import {ApiRequest, Builder} from "laravel-request";
import moment from "moment";
import {NotifyManager} from "notify-component";
import io from 'socket.io-client';


Builder.availableMethod = [
  ...Builder.availableMethod,
  ...[
    'whereAccount',
    'whereIncomeType',
    'whereSalaryType',
    'whereSpendingType',
    'whereObligationType',
    'wherePropertyType',
    'whereInvestType',
    'whereCurrencyType',
    'whereAccountType',
    'whereInsuranceType',
    'tasksOrder',
    'contactsOrder'
  ]
]

console.log('Builder.availableMethod inited')

IndexedDBCache.clearExpiredData();


ApiRequest.notifyClass = NotifyManager;

moment.locale('ru');
window.i18n = {};
window.io = io;

flatpickr.localize(Russian);
